// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "982e4e08-dirty",
    "hash": "982e4e08",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "982e4e08-dirty",
    "semverString": null,
    "version": "3.6.4",
    "branch": "(HEAD detached at 982e4e08)"
};
/* tslint:enable */
